export default "__VITE_ASSET__694956a8__"